import Vue from '@/main'
import { CustomerChatService } from "@/db/customerChat_service";
import { ChatTicketService } from "@/db/chatTicket_service";
import store from "@/store/store.js"
import { CustomerService } from "@/db/customer_service";
import {CustomerChatReactionsService} from "../db/customerChatReactions_service";
import {OrderByMsgService} from "../db/orderByMsg_service";

export const campaignUpdated = (data) => {
  // console.log('socket CampaignUpdated received')
  Vue.$events.fire('CampaignUpdated', data)
}

export const campaignCreated = (data) => {
  // console.log('socket CampaignCreated received')
  Vue.$events.fire('CampaignCreated', data)
}

export const campaignWarning = (data) => {
  // console.log('socket campaignWarning received')
  Vue.$events.fire('CampaignWarning', data)
}

export const reportWarning = (data) => {
  // console.log('socket reportWarning received', data)
  Vue.$events.fire('ReportWarning', data)
}

export const chatNotification = (data) => {
  // console.log('socket ChatNotification received', data)
  Vue.$events.fire('ChatNotification', data)
}

export const globals_SettingChanged = (data) => {
  // console.log('socket Globals/SettingChanged received')

  if (data.setting.tag === 'whatsapp_status') {
    Vue.$events.fire('UpdateWhatsappStatus');
  } else if (data.setting.tag === 'maintenance_status'){
    Vue.$events.fire('UpdateMaintenanceStatus');
  }
}

export const chatTicketClosed = async (data) => {
  // console.log('ChatTicketClosed', data);
  const ctService = new ChatTicketService();
  await ctService.closeTicket(data.chatTicket)
  Vue.$events.fire('ChatTicketClosed', data)
}

export const chatTicketTransferred = async (data) => {
  // console.log('socket ChatTicketTransferred received', data)
  const ctService = new ChatTicketService();
  await ctService.transferChat(data)
  Vue.$events.fire('ChatTicketTransferred', data)
}

export const chatTicketTransferring = (data) => {
  //console.log('socket ChatTicketTransferring received')
  Vue.$events.fire('ChatTicketTransferring', data)
}

export const chatTicketResearchCanceled = (data) => {
  // console.log('socket researchCanceled received')
  Vue.$events.fire('chatTicketResearchCanceled', data)
}

export const customerBlacklisted = (data) => {
  // console.log('socket CustomerBlacklisted received')
  Vue.$events.fire('CustomerBlacklisted', data)
}

export const customerChatCreated = async (data) => {
  // console.log('customerChatCreated', data);
  const ccService = new CustomerChatService();
  if (data.customerChat.type === 0 && data.customerChat.hash !== null && data.customerChat.hash !== undefined) {
    Vue.$events.fire('DeleteJobReceivedMessage', data.customerChat.hash)
    await ccService.removeInsert(data.customerChat, true);
  } else {
    await ccService.insert([data.customerChat], true, true, false, true, true);
  }
}

export const customerChatUpdated = async (data) => {
  // console.log('CustomerChatUpdated')
  const ccService = new CustomerChatService();
  await ccService.update([data], true);
}

export const customerChatAckChanged = async (data) => {
  const ccService = new CustomerChatService();
  // console.log('CustomerChatAckChanged')
  if (data.customerChat.hash !== null && data.customerChat.hash !== undefined) {
      await ccService.updateAckCustomerChat(data.customerChat)
  }
  Vue.$events.fire('RefreshObserverChatData', data.customerChat)
  Vue.$events.fire('CustomerChatAckChanged', data)
}

export const reactionsChanged = async (data) => {
  // console.log('ReactionsChanged', data)
  const method = data['type'];
  const ccReactionService = new CustomerChatReactionsService();
  await ccReactionService[method]([data['reaction']], true, true)
}

export const chatTicketTransfer = (data) => {
  // console.log('socket ChatTicketTransfer received', data)
  Vue.$events.fire('ChatTicketTransfer', data)
}

export const customerCreatedToChat = (data) => {
  console.log('socket CustomerCreatedToChat received', data)
  Vue.$events.fire('CustomerCreatedToChat', data)
}

export const groupOfCustomersUpdated = (data) => {
  // console.log('socket GroupOfCustomersUpdated received')
  Vue.$events.fire('GroupOfCustomersUpdated', data)
}

export const newOrderProductInserted = (data) => {
  // console.log('socket NewOrderProductInserted received', data)
  Vue.$events.fire('NewOrderProductInserted', data)
}

export const newPurchaseValueOfOrder = (data) => {
  // console.log('socket NewOrderProductInserted received', data)
  Vue.$events.fire('NewPurchaseValueOfOrder', data)
}

export const instanceUpdated = (data) => {
  // console.log('socket InstanceUpdated received')
  Vue.$events.fire('InstanceUpdated', data)
}

export const metaMessageTemplateUpdated = (data) => {
  console.log('socket MetaMessageTemplateUpdated received')
  Vue.$events.fire('MetaMessageTemplateUpdated', data)
}

export const deleteChatTicketTransfer = (data) => {
  // console.log('socket DeleteChatTicketTransfer received')
  Vue.$events.fire('DeleteChatTicketTransfer', data)
}

export const notifyChatTicketChanged = async (data) => {
  console.log('notifyChatTicketChanged', data);
  const ctService = new ChatTicketService();
  await ctService.updateTicket(data.chatTicket);
  Vue.$events.fire('ChatTicketChanged', data)
}

export const chatTicketCreated = async (data) => {
  // console.log('ChatTicketCreated', data);
  const ctService = new ChatTicketService();
  await ctService.removeAndInsert([data.chatTicket], true)
}

export const chatTicketIsResearch = async (data) => {
  // console.log('NotifyChatTicketIsResearch', data);
  const ctService = new ChatTicketService();
  await ctService.updateResearch(data.chatTicket)
}

export const chatTicketChangeDepartment = async (data) => {
  console.log('chatTicketChangeDepartment', data);
  if ( 
      (
        !!store.state.AppActiveUser.userDepartment 
        && !!data.chatTicket.inbox_department_id
        && store.state.AppActiveUser.role.name !== 'administrador'
        && store.state.AppActiveUser.userDepartment.id !== data.chatTicket.inbox_department_id
      ) || (
        !store.state.AppActiveUser.userDepartment  
        && !!data.chatTicket.inbox_department_id
        && store.state.AppActiveUser.role.name !== 'administrador' 
      )
  ) {
    const ctService = new ChatTicketService();
    await ctService.removeChatTicket(data.chatTicket)
  }
}

export const notifyBotIsActive = async (data) => {
  // console.log('NotifyBotIsActive', data);

  const ctService = new ChatTicketService();
  await ctService.updateBotIsActive(data.chatTicket, data.type);

  Vue.$events.fire('notifyBotIsActiveChanged', data.chatTicket);
}

export const notifyTriageFlowFinishedByMessageLimit = async (data) => {
  // console.log('notifyTriageFlowFinishedByMessageLimit', data);
  Vue.$events.fire('notifyTriageFlowFinishedByMessageLimit', data.chatTicket)
}

export const settingsChanged = async (data) => {
  console.log('settingsChanged', data);
  store.dispatch("settings/fetch")
}

export const stockImageChanged = (data) => {
  Vue.$events.fire('StockImageChanged', data)
}

export const customerChanged = async (data) => {
  // console.log('customerChanged', data);
  const cService = new CustomerService();
  await cService.update(data.customer, true, data['changePicture'], data['openTickets'])
}

export const updateHiddenItem = async (data) => {
  // console.log('UpdateHiddenItemEvent', data);
  Vue.$events.fire('UpdateHiddenItemEvent', data)
}

export const syncCustomersProducts = async (data) => {
  // console.log('SyncCustomersProducts', data);
  Vue.$events.fire('SyncCustomersProducts', data)
}

export const notifyIncident = async (data) => {
  // console.log('NotifyIncident', data);
  Vue.$events.fire('NotifyIncident', data)
}

export const updateItem = async (data) => {
  // console.log('UpdateItem', data);
  Vue.$events.fire('UpdateItem', data)
}

export const notifyVerification = async (data) => {
  // console.log('UpdateItem', data);
  Vue.$events.fire('NotifyVerification', data)
}

export const deleteItem = async (data) => {
  // console.log('DeleteItem', data);
  Vue.$events.fire('DeleteItem', data)
}

export const getCollections = async (data) => {
  // console.log('GetCollections', data);
  Vue.$events.fire('GetCollections', data)
}

export const createCollections = async (data) => {
  // console.log('CreateCollections', data);
  Vue.$events.fire('CreateCollections', data)
}

export const deleteCollection = async (data) => {
  // console.log('DeleteCollection', data);
  Vue.$events.fire('DeleteCollection', data)
}

export const updateCollection = async (data) => {
  // console.log('UpdateCollection', data);
  Vue.$events.fire('UpdateCollection', data)
}

export const orderByMsg = async (data) => {
  const ccOrderByMsgService = new OrderByMsgService();
  const customerChatId = data.customerChatId;

  data.products.forEach((product) => {
    data = {
      id: `${product.id}`,
      name: product.name,
      price: product.price,
      quantity: product.quantity,
      thumbnailId: product.thumbnailId,
      thumbnailUrl: product.thumbnailUrl,
      currency: product.currency,
      customer_chat_id: customerChatId
    }

    ccOrderByMsgService.insert([data], true, true)
  })

}

export const refreshContent = async (data) => {
  // console.log('RefreshContent', data);
  Vue.$events.fire('RefreshContent', data)
}

export const ping = () => {
  // console.log('socket pong received', Date())
  store.dispatch('socketConnectionCount', Date())
}

export const internalChatMessageCreated = (data) => {
  // console.log('socket InternalChatMessageCreated received', data)
  Vue.$events.fire('InternalChatMessageCreated', data)
}

export const internalChatMessagesAckChanged = (data) => {
  // console.log('socket InternalChatMessagesAckChanged received', data)
  Vue.$events.fire('InternalChatMessagesAckChanged', data)
}

export const notifySenderUpdated = async (data) => {
  // console.log('socket NotifySenderUpdated received', data)
  Vue.$events.fire('NotifySenderUpdated', data)
}